import { resolveDelegatedToolDisplay } from '@/lib/capabilities/display';

interface ToolPartLike {
  type: string;
  input?: unknown;
  output?: unknown;
}

interface MessageLike {
  id: string;
  parts: ToolPartLike[];
}

function asRecord(value: unknown): Record<string, unknown> | undefined {
  return value && typeof value === 'object' && !Array.isArray(value)
    ? value as Record<string, unknown>
    : undefined;
}

export function getWorkspaceOpenRequestKey(messages: MessageLike[]) {
  let latest: string | null = null;

  for (const message of messages) {
    for (let partIndex = 0; partIndex < message.parts.length; partIndex += 1) {
      const part = message.parts[partIndex];
      if (!part.type.startsWith('tool-')) continue;

      const rawToolName = part.type.slice('tool-'.length);
      const delegated = resolveDelegatedToolDisplay(rawToolName, part.input, part.output);
      const output = asRecord(delegated.output ?? part.output);

      if (
        delegated.toolName === 'showWorkspace' &&
        output?.success === true &&
        (output.action === undefined || output.action === 'open-artifact-panel')
      ) {
        latest = `${message.id}-${partIndex}`;
      }
    }
  }

  return latest;
}
